import './styles/globals.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { createRuntime } from './app/runtime';
import { initInstallPrompt } from './shared/pwa/install';
import { registerServiceWorker } from './shared/pwa/register';

const MOCK_API = import.meta.env.VITE_MOCK_API === '1';

async function start(): Promise<void> {
  // The browser's offer to install the app can come before the first render: keep it for the user menu.
  initInstallPrompt();
  if (MOCK_API) {
    // Dev-only mock backend (MSW). Never part of production bundles.
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }
  const runtime = createRuntime({ realtimeEnabled: !MOCK_API });
  // The texts of the language in use (one chunk with every module's); a failed load still renders (keys) and retries
  // when the language is switched.
  await runtime.ready.catch(() => undefined);
  const container = document.getElementById('root');
  if (!container) throw new Error('#root element missing');
  createRoot(container).render(
    <StrictMode>
      <App runtime={runtime} />
    </StrictMode>,
  );
  // The service worker (installable app, offline page, web push). Not with the mock API: MSW's worker owns the scope there.
  if (!MOCK_API) registerServiceWorker();
}

void start();
